import _ from 'lodash'

const errorReducer = (state, action) => ({
  ...state,
  isLoading: false,
  isBatchSuccessful: false,
  errorInfo: {
    status: action.status,
    statusText: action.statusText,
  },
})

/**
 * Saved search reducer, subset of dataTable reducers and exported from toolkit thru dataTable
 *
 * @param {string} tableType
 * @param {object} state
 * @param {object} action
 */
export const savedSearchesReducer = (
  tableType,
  state = { isDirty: true },
  action
) => {
  switch (action.type) {
    case `STORE_SAVED_SEARCHES_${tableType}`:
      return {
        ...state,
        searches: _.sortBy(action.savedSearches, ['saved_search_name']),
      }
    case `STORE_ONE_SAVED_SEARCH_${tableType}`:
      // eslint-disable-next-line no-case-declarations
      const newSearches = action.savedSearches.map(savedSearch =>
        savedSearch.saved_search_id === action.searchToUpdate.saved_search_id
          ? { ...action.searchToUpdate }
          : savedSearch
      )
      return { ...state, searches: newSearches }
    case `STORE_SELECTED_SEARCH_ID_${tableType}`:
      return { ...state, selectedSearchId: action.selectedSearchId }
    case `STORE_SAVED_SEARCH_DIRTY_${tableType}`:
      return { ...state, isDirty: action.isDirty }
    case `STORE_SAVED_SEARCH_DIRTY_COLUMNS_${tableType}`:
      return { ...state, dirtyColumns: action.dirtyColumns }
    case `FETCH_FAILURE_${tableType}_FOR_SAVED_SEARCHES`:
      return errorReducer(state, action)
    default:
      return state
  }
}
